import { eventSender } from 'Lib/event-sender/event-sender';

$('.filter-row__item').on('click', function () {
    eventSender.customDL({
        event: 'eksmo',
        eventAction: 'filter',
        eventCategory: 'microchast',
        eventLabel: $(this).text(),
    });
});